import AppDispatcher from './../flux/AppDispatcher';
import SystemConstants from './../constants/SystemConstants';
var systemDispatcher = AppDispatcher.get(SystemConstants.Internal.DISPATCHER_NAME);
var printFunctionCb: any = null;
var SystemActions = {
    PublicActions: {
        displayWarningMessage(msgObj: IMessageObject): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.MESSAGE_DISPLAY,
                type: SystemConstants.MessageType.Warning,
                msgObj: msgObj
            });
        },

        displayErrorMessage(msgObj: IMessageObject): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.MESSAGE_DISPLAY,
                type: SystemConstants.MessageType.Error,
                msgObj: msgObj
            });
        },

        displayInfoMessage(msgObj: IMessageObject): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.MESSAGE_DISPLAY,
                type: SystemConstants.MessageType.Info,
                msgObj: msgObj
            });
        },

        displayConfirmationMessage(msgObj: IMessageConfirmObject): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.MESSAGE_DISPLAY,
                type: SystemConstants.MessageType.Confirmation,
                msgObj: msgObj
            });
        },

        displayYesNoMessage(msgObj: IMessageConfirmObject): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.MESSAGE_DISPLAY,
                type: SystemConstants.MessageType.YesNo,
                msgObj: msgObj
            });
        },

        displaySaveChangesDialog(msgObj: IMessageConfirmObject): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.MESSAGE_DISPLAY,
                type: SystemConstants.MessageType.ConfirmUserChanges,
                msgObj: msgObj
            });
        },

        displaySuccessMessage(msgObj: IMessageObject): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.MESSAGE_DISPLAY,
                type: SystemConstants.MessageType.Success,
                msgObj: msgObj
            });
        },

        removeMessage(key: string): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.MESSAGE_REMOVE,
                key: key
            });
        },

        clearAllMessages(): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.MESSAGE_CLEAR_ALL
            });
        },

        beginAction(action: string): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.ACTION_IN_PROGRESS,
                action: action
            });
        },

        endAction(action: string): void {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.ACTION_COMPLETED,
                action: action
            });
        },

        //displayPrint() {
        //    systemDispatcher.dispatch({
        //        actionType: SystemConstants.Action.DISPLAY_PRINT,
        //        display: true
        //    });
        //},

        //cancelPrint() {
        //    systemDispatcher.dispatch({
        //        actionType: SystemConstants.Action.DISPLAY_PRINT,
        //        display: false
        //    });
        //},

        print() {
            //systemDispatcher.dispatch({
            //    actionType: SystemConstants.Action.DISPLAY_PRINT,
            //    display: false
            //});

            return printFunctionCb && printFunctionCb((div: HTMLElement) => {
                let iframe = document.createElement('iframe');

                iframe.style.position = 'absolute';
                iframe.style.zIndex = '-1000';
                iframe.style.top = '100%';
                iframe.style.height = '0';
                iframe.style.width = '0';
                iframe.style.overflow = 'scroll';

                document.body.appendChild(iframe);

                iframe.contentWindow.onafterprint = (ev) => {
                    if (iframe.remove) {
                        iframe.remove();
                    } else {
                        iframe.parentNode.removeChild(iframe);
                    }
                };

                iframe.contentDocument.open();
                iframe.contentDocument.write(div.innerHTML);
                iframe.contentDocument.close();

                iframe.contentWindow.document.close();
                iframe.contentWindow.focus();

                let contentDoc = iframe.contentDocument || iframe.contentWindow.document;
                let rdyFunction = () => {
                    if (iframe.contentDocument.readyState === 'complete') {
                        iframe.contentWindow.print();

                        if (iframe.contentWindow) iframe.contentWindow.close();
                    }
                };

                setTimeout(() => {
                    rdyFunction();
                    if (iframe.contentDocument.readyState !== 'complete') {
                        iframe.contentDocument.onreadystatechange = rdyFunction;
                    }
                }, 250);
            });
        },

        registerPrint(cb: (width?: number, height?: number) => void) {
            printFunctionCb = cb;
        },

        disableShareLink() {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.DISABLE_SHARE,
                data: true
            });
        },

        enableShareLink() {
            systemDispatcher.dispatch({
                actionType: SystemConstants.Action.DISABLE_SHARE,
                data: false
            });
        }
    }
}

export default SystemActions;